// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/actionTypes');

const initialState = Immutable.fromJS({
    isFetching: false,
    isSuccess: false,
    isError: false,
    isInvalid: false,
    validationMessage: {
        titleText: '',
        descriptionText: '',
        buttonText: '',
        navigationFlowConfirmationButton: ''
    }
});

const generateRejectedMessage = ({ response }) => {
    const {
        context,
        labelKey,
        descriptionKey,
        textConfirmationButton,
        navigationFlowConfirmationButton
    } = response

    return {
        titleText: `${context}-${labelKey}`,
        descriptionText: `${context}-${descriptionKey}`,
        buttonText: `${context}-${textConfirmationButton}`,
        navigationFlowConfirmationButton
    }
};

const accountCancellation = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.TRANSFER_ACCOUNT_VALIDATION_REQUEST:
        case actionTypes.ACCOUNT_CANCELLATION_VALIDATION_REQUEST:
            return state.merge({
                isFetching: true,
                isSuccess: false,
                isInvalid: false,
                isError: false,
                validationMessage: {
                    titleText: '',
                    descriptionText: '',
                    buttonText: '',
                    navigationFlowConfirmationButton: ''
                }
            });

        case actionTypes.ACCOUNT_CANCELLATION_VALIDATION_SUCCESS:
            return state.merge({
                isFetching: false,
                isError: false,
                isSuccess: true,
            })
        
        case actionTypes.TRANSFER_ACCOUNT_VALIDATION_REJECTED:
        case actionTypes.ACCOUNT_CANCELLATION_VALIDATION_REJECTED:
            return state.merge({
                isInvalid: true,
                isFetching: false,
                isError: false,
                isSuccess: false,
                validationMessage: generateRejectedMessage(action.payload)
            })

        case actionTypes.TRANSFER_ACCOUNT_VALIDATION_FAILURE:
        case actionTypes.ACCOUNT_CANCELLATION_VALIDATION_FAILURE:
            return state.merge({
                isFetching: false,
                isSuccess: false,
                isError: true,
            });

        case actionTypes.ACCOUNT_CANCELLATION_VALIDATION_RESET:
            return initialState

        default:
            return state;
    }
};

module.exports = accountCancellation;
